import React, { useEffect, useMemo, useState } from "react";
import BarGraph from "./barGraph";
import RadialChart from "./radialCHart";
import { useDarkTheme } from "@/contexts/DarkTheme";
import axios from "axios";
import { API_URL } from "@/config";
import { AccentColor } from "@/helpers/types";
import { useTranslation } from "next-i18next";
type Props = {};

export default function GraphSection({}: Props) {
  const { darkTheme } = useDarkTheme();
  const { t } = useTranslation("marketplace");
  let [longShortDominance, setLongShortDominance]: any = useState({});
  let [entryExitDominance, setEntryExitDominance]: any = useState({});
  let [loading, setLoading] = useState(false);

  useEffect(() => {
    const url = new URL("/marketplace_long_short_dominance", API_URL);
    axios
      .get(url.toString(), {})
      .then((data: any) => {
        if (data?.statusText == "OK") {
          setLongShortDominance(data.data);
        } else {
          console.warn("err", data);
        }
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    const url = new URL("/marketplace_entry_exit_dominance", API_URL);
    axios
      .get(url.toString(), {})
      .then((data: any) => {
        if (data?.statusText == "OK") {
          setEntryExitDominance(data.data);
        } else {
          console.warn("err", data);
        }
      })
      .finally(() => setLoading(false));
  }, []);

  const tradesTriggeredWinloss = useMemo(() => {
    const totalWinTrades = longShortDominance?.long;
    const totalLossTrades = longShortDominance?.short;
    const totalTrades = totalWinTrades + totalLossTrades;

    const winPercentage =
      totalTrades > 0 ? Math.round((totalWinTrades / totalTrades) * 100) : 0;
    const lossPercentage =
      totalTrades > 0 ? Math.round((totalLossTrades / totalTrades) * 100) : 0;

    return [
      { name: "Long", value: winPercentage },
      { name: "Short", value: lossPercentage },
    ];
  }, [longShortDominance]);

  const tradesTriggeredEntryExit = useMemo(() => {
    const totalWinTrades = entryExitDominance?.opened;
    const totalLossTrades = entryExitDominance?.closed;
    const totalTrades = totalWinTrades + totalLossTrades;

    const winPercentage =
      totalTrades > 0 ? Math.round((totalWinTrades / totalTrades) * 100) : 0;
    const lossPercentage =
      totalTrades > 0 ? Math.round((totalLossTrades / totalTrades) * 100) : 0;

    return [
      { name: "Entry", value: winPercentage },
      { name: "Exit", value: lossPercentage },
    ];
  }, [entryExitDominance]);

  return (
    <div className="relative w-full flex-col flex sm:flex-row h-full">
      <div className="w-full sm:w-[77%]">
        <BarGraph t={t} />
      </div>
      <div
        className="w-full sm:w-[23%] flex sm:flex-col lg:justify-between mt-5 sm:mt-0 items-center"
        id="marketplace-graphs"
      >
        <div className="w-full h-[50%] max-w-[250px]">
          {Object.keys(tradesTriggeredEntryExit).length && (
            <RadialChart
              title={t("Entry/Exit Dominance")}
              backtestGraphRes={tradesTriggeredEntryExit}
              t={t}
              totalTrades={
                entryExitDominance?.opened + entryExitDominance?.closed
              }
            />
          )}
        </div>
        <div className="w-full flex flex-col items-center max-w-[250px]">
          <div className="text-[12px] flex text-center items-center mt-0 pt-0 font-semibold">
            {t("Long/Short Dominance")}
          </div>
          <div className="flex items-center justify-center mt-3">
            <div
              className={`w-[42px] h-[42px] bg-[var(--foreground-green)] rounded-full flex items-center justify-center mr-5`}
            >
              L
            </div>
            <div className="text-sm">{tradesTriggeredWinloss[0]?.value}%</div>
          </div>

          <div className="flex items-center justify-center mt-3">
            <div
              className={`w-[42px] h-[42px] bg-[var(--foreground-red)] rounded-full flex items-center justify-center mr-5`}
            >
              S
            </div>
            <div className="text-sm">{tradesTriggeredWinloss[1]?.value}%</div>
          </div>
        </div>
      </div>
    </div>
  );
}
